export const FETCH_REWARDS = 'reward/FETCH_REWARDS'
export const FETCH_REWARDS_SUCCESS = 'reward/FETCH_REWARDS_SUCCESS'
export const FETCH_REWARDS_FAILURE = 'reward/FETCH_REWARDS_FAILURE'
export const RESET_REWARDS = 'reward/RESET_REWARDS'

export const CLAIM_REWARD = 'reward/CLAIM_REWARD'
export const CLAIM_REWARD_SUCCESS = 'reward/CLAIM_REWARD_SUCCESS'
export const CLAIM_REWARD_FAILURE = 'reward/CLAIM_REWARD_FAILURE'
export const RESET_CLAIM_REWARD = 'reward/RESET_CLAIM_REWARD'

export const FETCH_CURRENT_GIFT = 'reward/FETCH_CURRENT_GIFT'
export const FETCH_CURRENT_GIFT_SUCCESS = 'reward/FETCH_CURRENT_GIFT_SUCCESS'
export const FETCH_CURRENT_GIFT_FAILURE = 'reward/FETCH_CURRENT_GIFT_FAILURE'

export const SET_CURRENT_GIFT = 'reward/SET_CURRENT_GIFT'
export const SET_CURRENT_GIFT_SUCCESS = 'reward/SET_CURRENT_GIFT_SUCCESS'
export const SET_CURRENT_GIFT_FAILURE = 'reward/SET_CURRENT_GIFT_FAILURE'

export const FETCH_SERVICES = 'reward/FETCH_SERVICES'
export const FETCH_SERVICES_SUCCESS = 'reward/FETCH_SERVICES_SUCCESS'
export const FETCH_SERVICES_FAILURE = 'reward/FETCH_SERVICES_FAILURE'


// WEBPACK FOOTER //
// ./src/store/reward/actionTypes.js